import { connect } from 'react-redux';
import { displayQueue } from 'store/slices/emoji/displayQueue';

export default connect(mapStateToProps, {
  clearDisplayQueue: displayQueue.actions.clearQueue,
});

function mapStateToProps(state, _ownProps) {
  const {
    emoji: { displayQueue },
    device: { performanceRate },
  } = state;

  return {
    displayQueue: displayQueue.filter((i) => i.count > 0),
    performanceRate,
  };
}
